import { Badge, Chip } from "@mui/material"
import FiberNewIcon from '@mui/icons-material/FiberNew';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import ChecklistIcon from '@mui/icons-material/Checklist';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PaidIcon from '@mui/icons-material/Paid';
import CancelIcon from '@mui/icons-material/Cancel';
import ChatBubbleTwoToneIcon from '@mui/icons-material/ChatBubbleTwoTone';
import { get_service_order_color } from "../Constants"
import { formatCustomerName, formatPhoneNumber } from ".";

export const get_service_order_status_icon = (status_type) => {
    return {
        'CREATED': <FiberNewIcon />,
        'IN_PROGRESS': <AccessTimeFilledIcon />,
        'WORK_COMPLETE': <ChecklistIcon />,
        'INVOICED': <PaidIcon />,
        'COMPLETED': <CheckCircleIcon />,
        'DECLINED': <CancelIcon />,
    }[status_type]
}

export const serviceOrderChip = (my_user, status_name, status_type, show_customer_communication) => {
    const color = get_service_order_color(my_user.client.service_order_statuses, status_name)
    const icon = get_service_order_status_icon(status_type)
    const chip = <Chip icon={icon} label={status_name} color={color} key={status_name} sx={{ lineHeight: '32px' }} />
    if (show_customer_communication) {
        return <Badge
            badgeContent={<ChatBubbleTwoToneIcon sx={{ height: '.65em', width: '.65em' }} />}
            color="grey"
            sx={{ p: 0 }}
            slotProps={{
                badge: { sx: { p: 0, top: 3, right: 3, background: 'rgba(0, 0, 0, 0.5)' } }
            }}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}>
            {chip}
        </Badge>
    } else {
        return chip
    }
}

export const calculate_service_estimated_minutes = (serviceOrder, service) => {
    let minutes = 0
    serviceOrder.service_order_work_history.forEach((workHistory) => {
        workHistory.service_order_work_history_entries.forEach((workHistoryEntry) => {
            if (workHistoryEntry.service_order_service_id === service.id) {
                minutes += workHistoryEntry.recorded_minutes
            }
        })
    })
    return minutes
}

const ALL_SERVICE_STATUS_TYPES_ORDERED = ['CREATED', 'ACQUIRING', 'READY', 'IN_PROGRESS', 'WORK_COMPLETE', 'INSTALLED', 'INVOICED', 'COMPLETED', 'DECLINED']
export const sort_custom_statuses = (statuses) => {
    return Object.keys(statuses ?? {}).sort(
        (a, b) => {
            const real_a = statuses[a]
            const real_b = statuses[b]
            if (real_a.type !== real_b.type) {
                return ALL_SERVICE_STATUS_TYPES_ORDERED.indexOf(real_a.type) - ALL_SERVICE_STATUS_TYPES_ORDERED.indexOf(real_b.type)
            } else {
                return real_a.order - real_b.order
            }
        })
}

export const template_service_communication = (location, serviceOrder, message, new_status) => {
    return message.replace(/{{customer_name}}/g, formatCustomerName(serviceOrder.customer))
        .replace(/{{customer_phone}}/g, formatPhoneNumber(serviceOrder.customer.phone))
        .replace(/{{customer_email}}/g, serviceOrder.customer.email)
        .replace(/{{customer_address}}/g, serviceOrder.customer.address)
        .replace(/{{customer_city}}/g, serviceOrder.customer.city)
        .replace(/{{customer_state}}/g, serviceOrder.customer.state)
        .replace(/{{customer_zip}}/g, serviceOrder.customer.zip)
        .replace(/{{location_name}}/g, location?.external_name)
        .replace(/{{service_order_number}}/g, serviceOrder.id)
        .replace(/{{service_order_old_status}}/g, serviceOrder.status_name)
        .replace(/{{service_order_new_status}}/g, new_status)
        .replace(/{{item_manufacturer}}/g, serviceOrder.customer_item.manufacturer)
        .replace(/{{item_model}}/g, serviceOrder.customer_item.model)
        .replace(/{{item_identifier}}/g, serviceOrder.customer_item.identifier)

}